import { FETCH_SUGGESTED } from './constants'

export const fetchSuggested = {
  request: (id, contentType, deviceId) => ({
    type: FETCH_SUGGESTED.REQUEST,
    id,
    contentType,
    deviceId
  }),
  success: (suggested) => ({ type: FETCH_SUGGESTED.SUCCESS, suggested })
}
